import { Component, ChangeDetectorRef, ChangeDetectionStrategy, ViewRef, Input, ViewChild, ElementRef, NgZone, AfterViewInit, HostListener } from '@angular/core';
import { Column } from '../../models/column';
import { ValueField } from '../../models/valuefield';
import { MDGColumnsComponent } from './MDG.Columns';
import { FormatPipe } from '../../pipe/format.pipe';
import { HelperService } from '../../Services/Helper.Service';
import { fromEvent } from 'rxjs';

declare const pdfMake: any;

@Component({
  selector: 'mdg-detail',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div [style.display]="showDetail ? '' : 'none'" class='mdg-options-container'>
  <div class="mdg-options-popup-container">
    <div class='row'>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
        <div class='row'>
          <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6">
            <h3>
              <i class="fa fa-fw fa-table"></i> Details</h3>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12 col-lg-6 text-lg-right text-md-right text-sm-right">
            <h3 title="Close">
              <span class="cursor-pointer btn btn-default btn-sm no-radius" (click)='PrintData()' title="Export to pdf">
                <i class="fa fa-fw fa-print"></i> Print</span>
              <span class="cursor-pointer btn btn-default btn-sm no-radius" (click)='ExportToPDF()' title="Export to pdf">
                <i class="fa fa-fw fa-file-pdf-o"></i> PDF</span>
              <span class="cursor-pointer btn btn-default btn-sm no-radius" (click)='ExportToExcel()' title="Export to excel">
                <i class="fa fa-fw fa-file-excel-o"></i> Excel</span>
              <span class="cursor-pointer btn btn-default btn-sm no-radius" (click)='ShowColumnOption()' title="Select Columns">
                <i class="fa fa-fw fa-filter"></i> Columns</span>
              <span class="cursor-pointer btn btn-default btn-sm no-radius" (click)='showDetail = false' title="Close">
                <i class="fa fa-fw fa-times"></i> Close</span>
              <!-- <span class="cursor-pointer" (click)='showDetail = false'>&times;</span> -->
            </h3>
          </div>
        </div>
        <div class='row' *ngIf="showDetail">
          <div class="col-md-4 col-sm-4 col-xs-12 col-lg-4 buffer-5-0 font-14" *ngIf="rowVal !== undefined && rowVal !== ''">
            <span>
              <b>
                <u>Row</u>
              </b>
            </span>
            <div *ngFor="let item of iRow; let r = index">
              <b>{{selectedRows[r].displayName}} : </b> {{item}}
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-12 col-lg-4 buffer-5-0 font-14" *ngIf="colVal !== undefined && colVal !== ''">
            <span>
              <b>
                <u>Column</u>
              </b>
            </span>
            <div *ngFor="let item of iCol; let c = index">
              <b>{{selectedColumns[c].displayName}} : </b> {{item}}
            </div>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-12 col-lg-4 buffer-5-0 font-14">
            <span>
              <b>
                <u>Value</u>
              </b>
            </span>
            <div>
              <b>{{valVal.column.valueField ? valVal.column.displayName : valVal.mathFn.Name + ' of ' +
                valVal.column.displayName}} : </b>{{value !== undefined && value !== '' ? value
              : '[Empty]'}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 content mdg-detail-container-div no-padding">
        <div #dHeader class="mdg-detail-header-div">
          <table class="mdg-detail" *ngIf="showDetail">
            <thead #detailTableHeader>
              <tr>
                <th class="bg-f7f7f7 font-bold detail-cell" *ngFor="let col of displayColumns" [title]="col.displayName">{{col.displayName}}</th>
              </tr>
            </thead>
          </table>
        </div>
        <div #dBody class="mdg-detail-body-div">
          <table class="mdg-detail" *ngIf="showDetail">
            <tbody #detailTableBody>
              <tr *ngFor="let d of data">
                <td *ngFor="let col of displayColumns" [title]="d[col.colName] | format:col">{{d[col.colName] |
                  format:col}}</td>
              </tr>
              <tr *ngIf="data.length === 0">
                <td colspan="displayColumns.length">No Records Found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<mdg-columns #columns (updateColumns)='onUpdateColumns($event)'></mdg-columns>
`
})
export class MDGDetailComponent implements AfterViewInit {
  @Input() columns: Column[] = [];
  @Input() selectedColumns: Column[] = [];
  @Input() selectedRows: Column[] = [];
  @Input() selectedValues: ValueField[] = [];

  @ViewChild('columns') fcolumns: MDGColumnsComponent;
  @ViewChild('detailTableHeader') detailTableHeader: ElementRef;
  @ViewChild('detailTableBody') detailTableBody: ElementRef;
  @ViewChild('dHeader') dHeader: ElementRef;
  @ViewChild('dBody') dBody: ElementRef;

  displayColumns: Column[] = [];

  selColumns: Column[] = [];
  showDetail: boolean = false;
  rowVal: string = '';
  colVal: string = '';
  valVal: ValueField;
  value: any = '';
  data: any[] = [];
  iRow: any[] = [];
  iCol: any[] = [];

  ngAfterViewInit() {
    this.zone.runOutsideAngular(() => {
      fromEvent(this.dBody.nativeElement, 'scroll')
        .subscribe(res => {
          this.onScroll(res);
        });
    });
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.showDetail && !this.fcolumns.showColumns) {
      this.showDetail = false;
    }
  }

  constructor(private cdRef: ChangeDetectorRef, private helper: HelperService, private format: FormatPipe, private zone: NgZone) {
    this.displayColumns = this.columns;
  }

  onScroll(event: any) {
    this.dHeader.nativeElement.scrollLeft = event.target.scrollLeft;
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
  }

  ShowDetail(data: any[], row: any, col: any, val: ValueField, value: any) {
    this.iRow = [];
    this.iCol = [];
    if (row !== undefined && row !== null && row !== '') {
      this.iRow = this.helper.copyArray(row);
    }
    if (col !== undefined && col !== null && col !== '') {
      this.iCol = this.helper.copyArray(col);
    }
    let i = 0;
    this.iRow.forEach(() => {
      this.iRow[i] = this.format.transform(this.iRow[i], this.selectedRows[i]);
      i++;
    });
    i = 0;
    this.iCol.forEach(() => {
      this.iCol[i] = this.format.transform(this.iCol[i], this.selectedColumns[i]);
      i++;
    });
    i = 0;
    this.data = data;
    this.selColumns = [];
    this.selColumns = this.helper.copyArray(this.columns);
    if (this.displayColumns.length === 0) {
      this.displayColumns.push(...this.selectedRows);
      this.displayColumns.push(...this.selectedColumns);
      this.displayColumns.push(...this.selectedValues.map(m => m.column));
    }
    setTimeout(() => {
      this.selColumns.forEach(scol => {
        scol.checked = this.displayColumns.filter(f => f.colName === scol.colName).length > 0;
      });
    }, 100);
    this.rowVal = this.iRow.filter((f: any) => f !== undefined && f !== null && f.toString().trim() !== '').join(', ');
    this.colVal = this.iCol.filter((f: any) => f !== undefined && f !== null && f.toString().trim() !== '').join(', ');
    this.valVal = val;
    this.value = value;
    this.showDetail = true;
    this.detectChanges();
  }

  ShowColumnOption() {
    this.fcolumns.ShowColumns(this.selColumns);
  }

  onUpdateColumns(cols: Column[]) {
    this.displayColumns = cols;
    this.selColumns.forEach(scol => {
      scol.checked = this.displayColumns.filter(f => f.colName === scol.colName).length > 0;
    });
  }

  ExportToExcel() {
    let pivotHeader = this.detailTableHeader.nativeElement.innerHTML;
    pivotHeader = pivotHeader.replace(/<th/g, '<th style="border-bottom:.5pt solid #696d72;border-top:.5pt solid #696d72;border-left:.5pt solid #696d72;border-right:.5pt solid #696d72; font-weight:bold;" ');

    const colSpan = this.displayColumns.length === 0 ? 1 : this.displayColumns.length;
    let header = '<tr>';
    let i = 0;
    if (this.rowVal !== undefined && this.rowVal !== null && this.rowVal !== '') {
      header += '<td style="border-bottom:.5pt solid #696d72;border-top:.5pt solid #696d72;border-left:.5pt solid #696d72;border-right:.5pt solid #696d72; font-weight:bold;">Row : </td>';
      header += '<td style="border-bottom:.5pt solid #696d72;border-top:.5pt solid #696d72;border-left:.5pt solid #696d72;border-right:.5pt solid #696d72; text-align:left;">';
      this.iRow.forEach(() => {
        header += '<b>' + this.selectedRows[i].displayName + ' : </d>' + this.iRow[i] + '<br/>';
        i++;
      });
      header += '</td>';
    }
    if (this.colVal !== undefined && this.colVal !== null && this.colVal !== '') {
      header += '<td style="border-bottom:.5pt solid #696d72;border-top:.5pt solid #696d72;border-left:.5pt solid #696d72;border-right:.5pt solid #696d72; font-weight:bold;">Column : </td>';
      header += '<td style="border-bottom:.5pt solid #696d72;border-top:.5pt solid #696d72;border-left:.5pt solid #696d72;border-right:.5pt solid #696d72; text-align:left;">';
      i = 0;
      this.iCol.forEach(() => {
        header += '<b>' + this.selectedColumns[i].displayName + ' : </d>' + this.iCol[i] + '<br/>';
        i++;
      });
      header += '</td>';
    }
    header += '<td style="border-bottom:.5pt solid #696d72;border-top:.5pt solid #696d72;border-left:.5pt solid #696d72;border-right:.5pt solid #696d72; font-weight:bold;">';
    header += (this.valVal.column.valueField ? this.valVal.column.displayName : this.valVal.mathFn.Name + ' of ' + this.valVal.column.displayName);
    header += '</td>';
    header += '<td style="border-bottom:.5pt solid #696d72;border-top:.5pt solid #696d72;border-left:.5pt solid #696d72;border-right:.5pt solid #696d72; text-align:left;">';
    header += (this.value !== undefined && this.value !== '' ? this.value : '[Empty]');
    header += '</td>';
    header += '</tr>';
    pivotHeader = '<tr><th colspan="' + colSpan + '"><table><thead>' + header + '</thead></table></th></tr><tr><th colspan="' + colSpan + '"></th></tr>' + pivotHeader;

    let pivotBody = this.detailTableBody.nativeElement.innerHTML;
    pivotBody = pivotBody.replace(/<th/g, '<th style="border-bottom:.5pt solid #696d72;border-top:.5pt solid #696d72;border-left:.5pt solid #696d72;border-right:.5pt solid #696d72; font-weight:bold;" ');
    pivotBody = pivotBody.replace(/<td/g, '<td style="border-bottom:.5pt solid #696d72;border-top:.5pt solid #696d72;border-left:.5pt solid #696d72;border-right:.5pt solid #696d72;" ');

    const content = '<table><thead>' + pivotHeader + '</thead><tbody>' + pivotBody + '</tbody></table>';

    const a = document.createElement('a');
    const mimeType = 'application/xls';
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    let filename = (this.rowVal !== undefined && this.rowVal !== null && this.rowVal !== '' ? this.rowVal.toString() : '') + (this.colVal !== undefined && this.colVal !== null && this.colVal !== '' ? this.colVal.toString() : '');
    filename = (filename.trim() === '' ? 'Pivot Data' : filename) + '.xls';
    a.href = url;
    a.setAttribute('download', filename);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  ExportToPDF() {
    let filename = (this.rowVal !== undefined && this.rowVal !== null && this.rowVal !== '' ? this.rowVal.toString() : '') + (this.colVal !== undefined && this.colVal !== null && this.colVal !== '' ? this.colVal.toString() : '');
    filename = (filename.trim() === '' ? 'Pivot Data' : filename) + '.pdf';
    pdfMake.createPdf(this.preparePDF()).download(filename);
  }

  PrintData() {
    pdfMake.createPdf(this.preparePDF()).print();
  }

  preparePDF() {
    const body: any[] = [];
    let headerCells: any[] = [];
    this.displayColumns.forEach(col => {
      headerCells.push({
        text: col.displayName,
        style: 'tableCell',
        alignment: col.header ? col.header.textAlign : ''
      });
    });
    body.push(headerCells);
    this.data.forEach(d => {
      headerCells = [];
      this.displayColumns.forEach(col => {
        headerCells.push({
          text: this.format.transform(d[col.colName.toString()], col),
          style: 'tableValue',
          alignment: col.cell ? col.cell.textAlign : ''
        });
      });
      body.push(headerCells);
    });
    const styledata: any = {};
    styledata['header'] = {
      fontSize: 14,
      bold: true,
      margin: [0, 0, 0, 10]
    };
    styledata['subheader'] = {
      fontSize: 12,
      bold: true,
      margin: [0, 10, 0, 5],
      color: 'black'
    };
    styledata['subheadervalue'] = {
      margin: [0, 10, 0, 5],
    };
    styledata['table'] = {
      margin: [0, 5, 0, 15]
    };
    styledata['tableCell'] = {
      bold: true,
      fontSize: 10,
      color: 'black'
    };
    styledata['titleValue'] = {
      fontSize: 10,
      color: 'black'
    };

    const pdfColCount = this.displayColumns.length;
    const pageInfo = this.helper.getPageInfo(pdfColCount);
    const content: any[] = [];
    content.push({ text: 'Pivot Details', alignment: 'center', style: 'header' });
    content.push({ canvas: [{ type: 'line', x1: 0, y1: 0, x2: pageInfo.pageWidth - 2 * 20, y2: 0, lineWidth: 0.5 }] });
    let i = 0;
    const columns: any[] = [];
    if (this.rowVal !== undefined && this.rowVal !== '') {
      const rowArr: any[] = [];
      const rColumns: any[] = [];
      rowArr.push({ text: 'Row ', width: 'auto', alignment: 'left', style: 'subheader' });
      i = 0;
      this.iRow.forEach(() => {
        rowArr.push(this.selectedRows[i].displayName + ' : ' + this.iRow[i]);
        i++;
      });
      rColumns.push(rowArr);
      columns.push({ columns: rColumns, width: '*' });
    }
    if (this.colVal !== undefined && this.colVal !== '') {
      const colArr: any[] = [];
      const cColumns: any[] = [];
      colArr.push({ text: 'Column ', width: 'auto', alignment: 'left', style: 'subheader' });
      i = 0;
      this.iCol.forEach(() => {
        colArr.push(this.selectedColumns[i].displayName + ' : ' + this.iCol[i]);
        i++;
      });
      cColumns.push(colArr);
      columns.push({ columns: cColumns, width: '*' });
    }
    const vColumns: any[] = [];
    vColumns.push({ text: this.valVal.column.valueField ? this.valVal.column.displayName + ' : ' : this.valVal.mathFn.Name + ' of ' + this.valVal.column.displayName + ' : ', width: 'auto', alignment: 'left', style: 'subheader' });
    vColumns.push({ text: this.value !== undefined && this.value !== '' ? this.value : '[Empty]', width: 'auto', alignment: 'left', style: 'subheadervalue' });
    // columns.push({ columns: vColumns, width: '*' });

    content.push({ columns: columns });
    content.push({ columns: vColumns });
    content.push({ canvas: [{ type: 'line', x1: 0, y1: 0, x2: pageInfo.pageWidth - 2 * 20, y2: 0, lineWidth: 0.5 }] });
    const table: any = {};
    table['headerRows'] = 1;
    table['body'] = body;
    content.push({ style: 'table', table: table });

    const pdfContent: any = {};
    pdfContent['content'] = content;
    pdfContent['styles'] = styledata;
    pdfContent['pageOrientation'] = pageInfo.pageOrientation;
    pdfContent['pageSize'] = pageInfo.pageSize;
    pdfContent['pageMargins'] = [20, 20, 20, 20];
    return pdfContent;
  }

  detectChanges() {
    setTimeout(() => {
      if (
        this.cdRef !== null &&
        this.cdRef !== undefined &&
        !(this.cdRef as ViewRef).destroyed
      ) {
        this.cdRef.detectChanges();
      }
    }, 250);
  }
}
